/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-escape */
import { 
    Wrap, 
    StyledButton as Button,
} from './styles';

import geoConfirm from 'services/utils/confirm';
import { getCurrentDate } from 'services/utils/date';
import { applyLabelSetting } from 'services/utils/layerUtils';

import GridHorizontal from './components/GridHorizontal';
import GridVertical from './components/GridVertical';
import geoBahiaLogoPrint from './imgs/geobahia-logo-print.png';
import inemaLogoPrint from './imgs/inema-logo-print.png';
import legendaNaoDisponivel from './imgs/legenda-nao-disponivel.png';
import imageNorthMap from './imgs/norte.png';

import PopupImage from '../../../../../../PopupImage';
import PrintTwoBaseMaps from '../../../../RemoteAnalysis/PrintTwoBaseMaps';
import PrintTwoBasemapsView from '../../../../RemoteAnalysis/PrintTwoBaseMaps/views/PrintTwoBasemapsView';

import JpegJpgIconMapCliked from 'assets/img/jpeg-jpg-icon-map-clicked.svg';
import JpegJpgIconMap from 'assets/img/jpeg-jpg-icon-map.svg';

import Icon from '@map/components/Icons';
import CircularProgress from '@material-ui/core/CircularProgress';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
// import * as turf from '@turf/turf';
import domtoimagemore from "dom-to-image-more";
import parseGeoraster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import { jsPDF } from 'jspdf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap, é uma biblioteca de mapeamento 
 * leve e de codigo aberto, utiliza um banco de dados geografico editável gratuito.
 */
import L from 'leaflet';
import NonTiledLayer from "leaflet.nontiledlayer";
/**
 * useEffect é um hook que permite executar efeitos colaterais em seus componentes, por exemplo: 
 * buscar dados, atualizar diretamente o DOM e cronômetros, ele aceita dois argumentos o segundo 
 * é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um componente de função, o estado 
 * geralmente se refere a dados ou propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useRef permite que persista valores entre renderizações, ele pode ser usado para armazenar 
 * um valor mutável que não causa uma nova renderização quando atualizado e pode ser usado para 
 * acessar diretamente um elemento do DOM.
 */
import { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import Scale from 'views/MapView/components/MapArea/components/Scale';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação dos componentes com o mapa.
 */
import { useMap, useModule } from 'views/MapView/hooks';
/**
 * Função responsável por abertura do modal para importar arquivos 
 *  
 * @param {boolean} onClose Fechar o modal
 * @returns Retorna o carregamento do projeto importado e fecha o modal depois.
 */
export const PrintView = ({ onClose }) => {
  const { map, layers, basemaps, changeAttributionDinamic } = useMap();  
  const { activeModule } = useModule();

  const mapInstanceLeft = useRef(null);
  const mapInstanceRight = useRef(null);
    
  const spaceToGrid = 40;  
  const maxInitialHeightMapPrint = 640;
  const [maxHeightImg, setMaxHeightImg] = useState(maxInitialHeightMapPrint);
  const maxInitialWidthMapPrint = 680;
  const [maxWidthImg, setMaxWidthImg] = useState(maxInitialWidthMapPrint);  
  const [mapLeafletPrint, setMapLeafletPrint] = useState(null);
  const [layersPrintMap, setLayersPrintMap] = useState([]);
  const [inicializedPrintMap, setInicializedPrintMap] = useState(false);
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [northCheck, setNorthCheck] = useState(false);
  const [gridCheck, setGridCheck] = useState(false);  
  const [externalSource, setExternalSource] = useState('');  
  const [hiddenLegends, setHiddenLegends] = useState(null);
  const [disableSubmitPrint, setDisableSubmitPrint] = useState(true);
  const [loading, setLoading] = useState(false);  
  const [layersToHide, setLayersToHide] = useState([]);  
  const [startPrint, setStartPrint] = useState(false);
  const [arrayCoordinatesY, setArrayCoordinatesY] = useState([])
  const [arrayCoordinatesX, setArrayCoordinatesX] = useState([])
  const [layersReady, setLayersReady] = useState(false);
  const [layoutOrientation] = useState('vertical'); 
  const [leftMapCoordinatesX, setLeftMapCoordinatesX] = useState([]);
  const [leftMapCoordinatesY, setLeftMapCoordinatesY] = useState([]);
  const [rightMapCoordinatesX, setRightMapCoordinatesX] = useState([]);
  const [rightMapCoordinatesY, setRightMapCoordinatesY] = useState([]);
  const [isActivePrintTwoBasemaps, setIsActivePrintTwoBasemaps] = useState(false);
  const [enabledPrintTwoBasemaps, setEnabledPrintTwoBasemaps] = useState(false);

  /**
   * Obtém imagem do mapa
   */
  const getImageMap = () => {
  // verifica se está no modo dois mapas
  if (enabledPrintTwoBasemaps) {    
    let elementTwoMaps = document.querySelector('[data-testid="two-maps-container"]');
    
    if (!elementTwoMaps) {
      elementTwoMaps = document.querySelector('.map-side div[style*="display: flex"]');
    }
    
    if (!elementTwoMaps) {
      const mapContainers = document.querySelectorAll('.leaflet-container');
      if (mapContainers.length >= 2) {
        elementTwoMaps = mapContainers[0].parentElement;
        const childMaps = elementTwoMaps.querySelectorAll('.leaflet-container');
        if (childMaps.length < 2) {
          elementTwoMaps = mapContainers[0].parentElement.parentElement;
        }
      }
    }
    
    if (!elementTwoMaps) {
      elementTwoMaps = document.querySelector('.map-side');
    }
    
    if (!elementTwoMaps || elementTwoMaps.offsetHeight === 0 || elementTwoMaps.offsetWidth === 0) {
      return Promise.reject(new Error('Container de dois mapas não encontrado'));
    }
    
    const controls = elementTwoMaps.querySelectorAll('.leaflet-control-zoom, .leaflet-control-attribution');
    const northIcons = elementTwoMaps.querySelectorAll('.two-maps-north-icon, .topRight');
    const scaleTwoMaps = elementTwoMaps.querySelectorAll('.scale, .bottomRight');

    controls.forEach((control) => {
      if (control) control.style.display = "none";
    });
    
    northIcons.forEach((icon) => {
      if (icon) icon.style.display = "none";
    });

     scaleTwoMaps.forEach((scaleTwo) => {
      if (scaleTwo) scaleTwo.style.display = "none";
    });
    
    return domtoimagemore.toPng(elementTwoMaps, { 
      cacheBust: true,
      height: elementTwoMaps.offsetHeight,
      width: elementTwoMaps.offsetWidth,
    }).finally(() => {
      controls.forEach((control) => {
        if (control) control.style.display = "";
      });
      
      northIcons.forEach((icon) => {
        if (icon) icon.style.display = "";
      });

      scaleTwoMaps.forEach((scaleTwo) => {
        if (scaleTwo) scaleTwo.style.display = "";
      });
    });
  } else {
    // configuração do mapa padrão
    let controlZoom = document.getElementsByClassName("leaflet-control-zoom leaflet-bar leaflet-control")[1];
    if (controlZoom) controlZoom.style.display = "none";
    
    let stripeCopyright = document.getElementsByClassName("leaflet-control-attribution leaflet-control")[1];    
    if (stripeCopyright) stripeCopyright.style.display = "none";
    
    let northIcon = document.querySelector('.topRight');
    if (northIcon) northIcon.style.display = "none";
    
    let elementLeafletMap = document.getElementById('leaflet-map-ajust-print');
    
    if (!elementLeafletMap) {
      return Promise.reject(new Error('Mapa não encontrado'));
    }
    
    if (elementLeafletMap.offsetHeight === 0 || elementLeafletMap.offsetWidth === 0) {
      return Promise.reject(new Error('Mapa com dimensões inválidas'));
    }
    
    return domtoimagemore.toPng(elementLeafletMap, { 
      cacheBust: true,
      height: elementLeafletMap.offsetHeight,
      width: elementLeafletMap.offsetWidth,
    }).finally(() => {
      if (controlZoom) controlZoom.style.display = "";
      if (stripeCopyright) stripeCopyright.style.display = "";
      if (northIcon) northIcon.style.display = "";
    });
  }
};

  /**
   * Obtém camadas válidas para as regras da impressão
   */
  const getValidLayers = useCallback(() => { 
    let validLayers = [];    

    layers.forEach((layer) => {
      if (layer.visible) {
        validLayers.push({aliasName: layer.alias, layer: layer});
      }           
    });

    return validLayers;
  }, [layers]);

  /**
   * Obtém camadas que podem ser impressas
   */
  const getLayersToPrintOut = useCallback(() => {    
    let layersToPrintOut = [];

    layers.forEach((l) => {
      let layerName = 
            l.type === 'externa'
              ? l.properties.titulo
              : l.alias;
      if(layersPrintMap.find((lpm) => lpm.aliasName === layerName) !== undefined &&
          layersToHide.find((lth) => lth.aliasName === layerName) === undefined) {
        layersToPrintOut.push(l);
      }
    });
    
    return layersToPrintOut;    
  }, [layers, layersPrintMap, layersToHide]);

  /**
   * Obtém lista das camadas NÃO imprimíveis
   */
  const getUnprintableLayers = () => {    
    let legendGraphicParams = {
      request: 'GetLegendGraphic',
      version: '1.0.0',
      format: 'image/png',      
      bbox: enabledPrintTwoBasemaps ? mapInstanceLeft.current.getBounds().toBBoxString() : map.getBounds().toBBoxString(),
      srcwidth: enabledPrintTwoBasemaps ? mapInstanceLeft.current.getSize().x : map.getSize().x,
      srcheight: enabledPrintTwoBasemaps ? mapInstanceLeft.current.getSize().y : map.getSize().y,
      srs: 'EPSG:4326', //WGS 84, para manter a compatibilidade com o sistema de coordenadas do Mapa
      /**
       * A ultima opção é a responsável por ocultar as legendas das areas que não estão dentro da
       * visualização do usuário.
       */
      legend_options: 'fontAntiAliasing:true;forceLabels:on;hideEmptyRules:true',
    };  
        
    let unprintableLayers = [];
    layersPrintMap.forEach((layerPrintMap) => {
      if (layerPrintMap.type === 'externa') {        
        let layerAppMapToTestRequestLegend = layers.find((l) => 
          l.properties?.titulo === layerPrintMap.aliasName
        );        
        unprintableLayers.push(new Promise((resolve, reject) => {
          return layerAppMapToTestRequestLegend.getServiceLegend(legendGraphicParams)
            .then((legend) => {              
              return resolve(false);
            }).catch(() => {              
              return resolve(layerPrintMap);
            })
        }));
      }
    });

    return Promise.all(unprintableLayers);
  };

  /**
   * Constroi lista das legendas
   */
  const buildStaticLegendListOnDOM = useCallback(() => {
    let arrStaticLegends = [];
    return new Promise((resolve, reject) => {
      getValidLayers().forEach((validLayer) => {     
        if (validLayer.layer.type === 'importada' || validLayer.layer.type === 'criada') {
          /**
           * TODO: Utilizar o spread operator no setHiddenLegends diretamente com a obtenção das legendas 
           * de camadas criadas/importadas. Talvez seja necessário um outra abordagem, ex: carregar em um 
           * passo específico somente esse tipo de legenda
           */
          arrStaticLegends.push(validLayer.layer.getStaticLegend(
              enabledPrintTwoBasemaps ? mapInstanceLeft.current.getBounds() : mapLeafletPrint.getBounds(),
              true,
              validLayer.layer.layerStyle.fillColor,
              validLayer.layer.layerStyle.fillOpacity,
              validLayer.layer.layerStyle.opacity
            ));
          setHiddenLegends([...arrStaticLegends]);        
        }
      });
      resolve(true);
    });
  }, [mapLeafletPrint, getValidLayers, enabledPrintTwoBasemaps]);
  
  /**
   * Obtém lista das legendas
   */
  const getLegendList = useCallback(() => {    
    let arrRequestLegends = [];
    let legendGraphicParams = {
      service: 'WMS',
      request: 'GetLegendGraphic',
      version: '1.0.0',
      format: 'image/png',      
      bbox: enabledPrintTwoBasemaps ? mapInstanceLeft.current.getBounds().toBBoxString() : mapLeafletPrint.getBounds().toBBoxString(),
      srcwidth: enabledPrintTwoBasemaps ? mapInstanceLeft.current.getSize().x : mapLeafletPrint.getSize().x,
      srcheight:  enabledPrintTwoBasemaps ? mapInstanceLeft.current.getSize().y : mapLeafletPrint.getSize().y,
      width: 18, //Necessário para compatibilizar com camas providas pelo MapServer
      height: 18, //Necessário para compatibilizar com camas providas pelo MapServer      
      /**
       * A ultima opção é a responsável por ocultar as legendas das areas que não estão dentro da
       * visualização do usuário.
       */
      legend_options: 'fontAntiAliasing:true;forceLabels:on;hideEmptyRules:true',
    };    
    let elLocalLegend = null;

    getLayersToPrintOut().forEach((validLayer) => {        
      if (validLayer.type === 'importada' || validLayer.type === 'criada') {                
        elLocalLegend = document.getElementById('legend-' + validLayer.id);
        if (elLocalLegend.offsetHeight > 0) {
          arrRequestLegends.push({
            aliasName: validLayer.alias, 
            dataType: validLayer.dataType,
            src: domtoimagemore.toPng(
                    elLocalLegend, 
                    {                       
                      height: elLocalLegend.offsetHeight,
                      width: elLocalLegend.offsetWidth,
                    }
                  )
          });
        }
      } else if (!validLayer.getService() || validLayer.getService() === 'WMS') {
        legendGraphicParams.layer = validLayer.getLayerNameParam();
        legendGraphicParams.SRS = validLayer.properties.SRS
                                    ? validLayer.properties.SRS
                                    : 'EPSG:4326'; //WGS 84, para manter a compatibilidade com o sistema de coordenadas do Mapa
        arrRequestLegends.push({
          aliasName: validLayer.type === 'externa' ? validLayer.properties.titulo : validLayer.alias,
          dataType: validLayer.dataType,
          src: validLayer.getServiceLegend(legendGraphicParams)
            .then((base64image) => {
              return base64image;
            }).catch((error) => {
              return legendaNaoDisponivel;
            })
        });
      }
    });

    return Promise.all(arrRequestLegends.map(function(legend) {
      return {...legend};      
    }));
  }, [mapLeafletPrint, enabledPrintTwoBasemaps, getLayersToPrintOut]);

  /**
   * Retorna objeto contendo largura, altura e url base64 da imagem
   */
   const convertImagesBase64ToObjWithDimensions = (arrLegendsBase64) => {    
    let arrImageBase64WithDimensions = [];
    arrLegendsBase64.forEach((responseBase64) => {              
      arrImageBase64WithDimensions.push(new Promise((resolve, reject) => {
        return responseBase64.src.then((imgBase64src) => {          
          let i = new Image();
          i.src = imgBase64src;
          i.onload = function() {            
            resolve({
              name: responseBase64.aliasName,
              dataType: responseBase64.dataType,
              w: i.width, 
              h: i.height, 
              src: imgBase64src
            });
          };
          i.onerror = () =>{
            resolve({
              name: responseBase64.aliasName,
              dataType: responseBase64.dataType,
              w: 145, 
              h: 20, 
              src: legendaNaoDisponivel
            });
          }
        });
      }));
    });
    return Promise.all(arrImageBase64WithDimensions);        
  };

  const decode = (str) => {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = str;
    return textArea.value;
  };

  const getAdjustedCopyright = () => {
  let copyright = "";
  let textCopyright = "";
  
  // Obtem copyright original do mapa
  map.eachLayer(function(layer) {
    if (layer.options?.attribution) {
      copyright = layer.options.attribution;        
      let div = document.createElement("div");
      div.innerHTML = copyright;
      textCopyright = div.textContent || div.innerText || "";
    }
  });

  // Se for modo dois mapas, ajusta o formato de copyright
  if (enabledPrintTwoBasemaps) {
    try {
      const leftSide = localStorage.getItem('leftSide');
      const rightSide = localStorage.getItem('rightSide');
      
      if (leftSide && rightSide && textCopyright) {
        const copyrightPattern = /©\s*(\d{1,2}\/\d{4})\s*Planet Labs Inc\./i;
        
        if (copyrightPattern.test(textCopyright)) {
          // Substituir o padrão existente pelo novo formato
          textCopyright = textCopyright.replace(
            copyrightPattern, 
            `© ${leftSide} - ${rightSide} Planet Labs Inc.`
          );
        } else {
          // Se não encontrar o padrão, adiciona as datas de forma genérica
          if (textCopyright.includes('Planet Labs Inc.')) {
            textCopyright = textCopyright.replace(
              'Planet Labs Inc.',
              `${leftSide} - ${rightSide} Planet Labs Inc.`
            );
          }
        }
      }
    } catch (error) {
      console.error('Erro ao ajustar copyright:', error);
    }
  }

  return textCopyright;
};

  /**
   * Constroi PDF com elementos básicos: Cabeçalho, mapa e lista de legendas
   */
  const buildBasicPdf = useCallback((doc, arrCustomObjImg) => {
  // Estilos
  doc.setTextColor("#5E5E5E");
  doc.setDrawColor("#5E5E5E");
  doc.setFillColor("#FFFFFF");

  // Cabeçalho
  doc.setFontSize(15);
  doc.setFont("Helvetica", "normal");
  doc.text(title, 36, 30);     
  doc.addImage(geoBahiaLogoPrint, "JPEG", 510, 22, 0, 0, '', 'NONE');
  doc.addImage(inemaLogoPrint, "JPEG", 562, 21, 0, 0, '', 'NONE');
  doc.line(36, 34, 595, 34);
  doc.setFontSize(9);    
  doc.text(subtitle, 36, 44);
  doc.text("Mapa elaborado em " + getCurrentDate() + ", Bahia", 476, 44); 

  // Copyright do mapa base - para dois mapas
  doc.setFontSize(7);
  const adjustedCopyright = getAdjustedCopyright();
  doc.text(decode(adjustedCopyright), 36, 428);
  let copyright = "";
  let textCopyright = "";
  map.eachLayer(function(layer) {
    if (layer.options?.attribution) {
      copyright = layer.options.attribution;        
      let div = document.createElement("div");
      div.innerHTML = copyright;
      textCopyright = div.textContent || div.innerText || "";
    }
  });

  // Linha vertical separadora
  doc.line(430, 60, 430, 420);

  // Cores de preenchimento e contorno dos retângulos
  // delimitadores das sessões inferiores
  // Retângulo legenda
  // doc.roundedRect(15, 500, 210, 120, 0, 0, "FD");
  // // Retângulo fonte externa
  // doc.roundedRect(235, 500, 100, 55, 0, 0, "FD");
  // // Retângulo fonte
  // doc.roundedRect(235, 565, 100, 55, 0, 0, "FD");
  // // Retângulo mapa de referência
  // doc.roundedRect(345, 500, 85, 120, 0, 0, "FD");

  // Legendas
  let initialYPositionLegend = 65; //510
  let initialLeftPositionLegend = 440;    
  doc.setFontSize(8);
  doc.text("Legenda", initialLeftPositionLegend, initialYPositionLegend);
  initialYPositionLegend = initialYPositionLegend + 2;
  doc.line(initialLeftPositionLegend, initialYPositionLegend, initialLeftPositionLegend + 35, initialYPositionLegend);
  initialYPositionLegend = initialYPositionLegend + 10;     
  doc.setFontSize(7);          

  if (enabledPrintTwoBasemaps) {
    try {
      const leftSide = localStorage.getItem('leftSide');
      const rightSide = localStorage.getItem('rightSide');
      
      if (leftSide && rightSide && textCopyright) {
        const copyrightPattern = /©\s*(\d{1,2}\/\d{4})\s*Planet Labs Inc\./i;
        
        if (copyrightPattern.test(textCopyright)) {
          textCopyright = textCopyright.replace(
            copyrightPattern, 
            `© ${leftSide} - ${rightSide} Planet Labs Inc.`
          );
        } else {
          if (textCopyright.includes('Planet Labs Inc.')) {
            textCopyright = textCopyright.replace(
              'Planet Labs Inc.',
              `${leftSide} - ${rightSide} Planet Labs Inc.`
            );
          }
        }
      }
    } catch (error) {
      console.error('Erro ao ajustar copyright:', error);
    }
  }

  doc.text(decode(textCopyright), 36, 428);
  
  arrCustomObjImg.forEach((customObjImg, index) => {      
    // Verifica se a imagem da legenda possui dimensões válidas
    if (customObjImg.h > 1 && customObjImg.w > 3) {        
      doc.text(customObjImg.name, initialLeftPositionLegend, initialYPositionLegend);
      initialYPositionLegend = initialYPositionLegend + 5;
      // Verifica se a legenda NÃO é de uma camada do tipo raster
      if (customObjImg.dataType !== "Raster") {
        doc.addImage(customObjImg.src, "PNG", initialLeftPositionLegend, initialYPositionLegend, customObjImg.w - (0.6 * customObjImg.w), customObjImg.h - (0.6 * customObjImg.h), customObjImg.name + '_' + index, 'SLOW');
        initialYPositionLegend = initialYPositionLegend + (customObjImg.h - (0.6 * customObjImg.h)) + 10;
      } else {
        initialYPositionLegend = initialYPositionLegend + 5;
      }              
    }      
  });
  
  // Retângulo branco após listagem de legendas para que 
  // as mesmas não exibidas atrás do mapa de referẽncia  doc.setDrawColor(255, 255, 255);
  doc.setFillColor(255, 255, 255);    
  externalSource
    ? doc.rect(435, 292, 192, 200, 'F')
    : doc.rect(440, 335, 192, 112, 'F');    

    // Anotação quado legenda da camada não pode ser impressa
    // OBS.: funciona apenas no PDF do FireFox
    // if (layersToHide.length > 0) {
    //   let arrAliasNameLayersNotPrint = layersToHide.map((l) => l.aliasName);
    //   doc.createAnnotation({
    //     type: "text",
    //     title: "note",
    //     bounds: {
    //       x: -20, //640,
    //       y: 20,
    //       w: 20,
    //       h: 20
    //     },
    //     contents: "As legendas das camadas: " + arrAliasNameLayersNotPrint + " não puderam ser impressas",      
    //     open: true
    //   });
    // }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [map, title, subtitle, externalSource, enabledPrintTwoBasemaps]);

  /**
   * Adiciona imagem do mapa
   */
  const addMapImage = useCallback((doc, mapImage) => {    
      let initXImageMap = gridCheck ? 59 : 36;
      let initYImageMap = 60;
      let finalHeight, finalWidth;
      
      if (enabledPrintTwoBasemaps) {
          initXImageMap = gridCheck ? 45 : 35;  
          finalWidth = 380;  
          finalHeight = (maxHeightImg * 0.584);
          
          // Adiciona marginTop para o modo dois mapas
          const adjustedY = initYImageMap - 13;
          
          doc.addImage(
              mapImage, 
              "PNG", 
              initXImageMap, 
              adjustedY,  // posição Y ajustada
              finalWidth, 
              finalHeight, 
              'mapImage', 
              'SLOW'
          );
          doc.mapImageEndY = adjustedY + finalHeight;
      } else {
          // Mantém configuração do mapa principal
          doc.addImage(
              mapImage, 
              "PNG", 
              initXImageMap, 
              initYImageMap, 
              0, 
              0, 
              'mapImage', 
              'SLOW'
          );
          finalHeight = maxHeightImg * 0.562;
          doc.mapImageEndY = initXImageMap + finalHeight;
      }
      
  }, [gridCheck, enabledPrintTwoBasemaps, maxHeightImg]);

  /**
   * Constroi grid vertical
   */
  const buildVerticalGrid = useCallback((doc, arrayCoordinatesY, initXPosition, initYPosition, endXPosition, endYPosition, numOfLines = 2) => {
    let lenghtLineXReferencePx = 2;
    let lenghtCoordinateXReferencePx = 22;
    let lenghtCoordinateYReferencePx = 1;
    
    doc.line(initXPosition, initYPosition, endXPosition, endYPosition);
    
    // constroi grid vertical do modo com dois mapas
    if (enabledPrintTwoBasemaps) {
        const totalHeight = endYPosition - initYPosition;
        const step = totalHeight / 7; // 8 pontos = 7 intervalos
        
        const arrYPositions = [];
        for (let i = 0; i < 8; i++) {
            arrYPositions.push(initYPosition + (step * i));
        }
        
        arrYPositions.forEach((yPosition, index) => {
            if (index < arrayCoordinatesY.length && arrayCoordinatesY[index]) {
                doc.line(initXPosition - lenghtLineXReferencePx, yPosition, endXPosition, yPosition);
                doc.text(arrayCoordinatesY[index], initXPosition - lenghtCoordinateXReferencePx, yPosition + lenghtCoordinateYReferencePx);
            }
        });
        
    } else {
        // cria grid vertical do mapa principal
        let arrYPositions = [initYPosition, endYPosition];

        if (numOfLines > 2) {            
            let divisor = numOfLines - 1;
            let numGrid = 1;      
            
            while (numOfLines > 2) {
                arrYPositions.push(((((endYPosition - initYPosition) / divisor) * numGrid) + initYPosition).toFixed(2));
                numOfLines--;
                numGrid++;
            }
        }

        arrYPositions.forEach((yPosition, index) => {
            doc.line(initXPosition - lenghtLineXReferencePx, yPosition, endXPosition, yPosition);
            if (arrayCoordinatesY[index]) {
                doc.text(arrayCoordinatesY[index], initXPosition - lenghtCoordinateXReferencePx, yPosition + lenghtCoordinateYReferencePx);
            }
        });
    }
}, [enabledPrintTwoBasemaps]);

const renderMapCoordinatesTwoMaps = (doc, coordinates, startX, endX, yPosition, lineHeight, textOffsetY, textOffsetX, mapName) => {
    if (!coordinates || coordinates.length !== 4) {
        return;
    }
    
    // Linha horizontal base
    doc.line(startX, yPosition, endX, yPosition);
    
    // otimiza posição para mapas menores
    const mapWidth = endX - startX;
    const positions = [
        startX + (mapWidth * 0.08),  // 8% - mais próximo da borda
        startX + (mapWidth * 0.32),  // 32%
        startX + (mapWidth * 0.68),  // 68%
        startX + (mapWidth * 0.92)   // 92% - mais próximo da borda
    ];
        
    // Desenha coordenadas
    positions.forEach((xPos, index) => {
        if (coordinates[index]) {
            // Linha vertical
            doc.line(xPos, yPosition, xPos, yPosition + lineHeight);
            // Texto da coordenada
            doc.text(coordinates[index], xPos - textOffsetX, yPosition + textOffsetY);
        }
    });
};


  /**
   * Constroi grid horizontal
   */
   const buildHorizontalGrid = useCallback((doc, arrayCoordinatesX, initXPosition, initYPosition, endXPosition, endYPosition, numOfLines = 2, leftCoordinatesX = null, rightCoordinatesX = null) => {
    
    const isTwoMapsMode = enabledPrintTwoBasemaps && layoutOrientation === 'vertical';
    
    if (isTwoMapsMode && leftCoordinatesX?.length > 0 && rightCoordinatesX?.length > 0) {
        // Ajusta tamanho das coordenadas horizontais para modo dois mapas
        const totalWidth = 367;  
        const separatorWidth = 2;
        const mapWidth = (totalWidth - separatorWidth) / 2;
        
        // Posições dos mapas
        const leftMapStartX = initXPosition;
        const leftMapEndX = initXPosition + mapWidth;
        const rightMapStartX = leftMapEndX + separatorWidth;
        const rightMapEndX = initXPosition + totalWidth;
        
        // Estilo para dois mapas
        const lenghtLineYReferencePx = 3;
        const lenghtCoordinateYReferencePx = 9;
        const lenghtCoordinateXReferencePx = 8; 
        
        doc.setFontSize(4);
        
        // RENDERIZA MAPA ESQUERDO (4 COORDENADAS) 
        renderMapCoordinatesTwoMaps(
            doc, leftCoordinatesX, leftMapStartX, leftMapEndX, 
            initYPosition, lenghtLineYReferencePx, lenghtCoordinateYReferencePx, 
            lenghtCoordinateXReferencePx, 'Esquerdo'
        );
        
        //  RENDERIZA MAPA DIREITO (4 COORDENADAS) 
        renderMapCoordinatesTwoMaps(
            doc, rightCoordinatesX, rightMapStartX, rightMapEndX, 
            initYPosition, lenghtLineYReferencePx, lenghtCoordinateYReferencePx, 
            lenghtCoordinateXReferencePx, 'Direito'
        );
        
        doc.setTextColor("#5E5E5E");
                
    } else {
        // ===== MAPA PRINCIPAL - LÓGICA ORIGINAL RESTAURADA =====
        let lenghtLineYReferencePx = 2;
        let lenghtCoordinateYReferencePx = 7;
        let lenghtCoordinateXReferencePx = 10;
        let arrXPositions = [initXPosition, endXPosition];

        doc.line(initXPosition, initYPosition, endXPosition, endYPosition);

        if (numOfLines > 2) {            
            let divisor = numOfLines - 1;
            let numGrid = 1;      
            
            while (numOfLines > 2) {
                arrXPositions.push(((((endXPosition - initXPosition) / divisor) * numGrid) + initXPosition).toFixed(2));
                numOfLines--;
                numGrid++;
            }
        }

        arrXPositions.forEach((xPosition, index) => {      
            doc.line(xPosition, initYPosition, xPosition, endYPosition + lenghtLineYReferencePx);
            if (arrayCoordinatesX[index]) {
                doc.text(arrayCoordinatesX[index], xPosition - lenghtCoordinateXReferencePx, initYPosition + lenghtCoordinateYReferencePx);
            }
        });
    }
}, [enabledPrintTwoBasemaps, layoutOrientation]);

const handleTwoMapsCoordinatesUpdate = useCallback((coords) => {
  setLeftMapCoordinatesX(coords.leftX || []);
  setLeftMapCoordinatesY(coords.leftY || []);
  setRightMapCoordinatesX(coords.rightX || []);
  setRightMapCoordinatesY(coords.rightY || []);
}, []);

  /**
   * Constroi o grid de coordenadas
   */
  const buildGrid = useCallback((doc) => {
    doc.setFontSize(5);
    doc.setDrawColor("#5E5E5E");
    
    if (enabledPrintTwoBasemaps) {
        // Para dois mapas - não usa esta função, usa buildGridWithParams
        return;
    } else {
        // constroi grid para mapa principal
        buildVerticalGrid(doc, arrayCoordinatesY, 57, 60, 57, 397, 8);
        buildHorizontalGrid(doc, arrayCoordinatesX, 59, 400, 419, 400, 8);
    }
}, [buildVerticalGrid, buildHorizontalGrid, arrayCoordinatesX, arrayCoordinatesY, enabledPrintTwoBasemaps]);

  
  /**
   * Adiciona imagem do norte sobre o mapa
   */
  const buildNorthMap = (doc) => {    
    doc.addImage(imageNorthMap, "PNG", 407, 65, 0, 0, '', 'NONE');    
  };
  
  /**
   * Obtém imagem da escala gráfica do mapa da tela de configuração
   */
  const getImageScale = () => {
    try {
        let elScaleMap = null;
        
        if (enabledPrintTwoBasemaps) {
            // Para dois mapas, busca a escala do mapa direito/inferior
            const twoMapsContainer = document.querySelector('[data-testid="two-maps-container"]');
            
            if (twoMapsContainer) {
                const rightMapContainer = twoMapsContainer.querySelector('.two-maps-right');
                if (rightMapContainer) {
                    elScaleMap = rightMapContainer.querySelector('.scale');
                }
            }
            
            // busca qualquer escala visível
            if (!elScaleMap) {
                const allScales = document.querySelectorAll('.scale');
                for (let scale of allScales) {
                    if (scale && scale.offsetWidth > 0 && scale.offsetHeight > 0) {
                        // Verifica se é do container dois mapas
                        if (scale.closest('[data-testid="two-maps-container"]')) {
                            elScaleMap = scale;
                            break;
                        }
                    }
                }
            }
        } else {
            // Mapa principal Geobahia
            const scaleElements = document.getElementsByClassName("scale");
            
            if (scaleElements.length > 1 && scaleElements[1] && scaleElements[1].offsetWidth > 0) {
                elScaleMap = scaleElements[1];
            } else if (scaleElements.length > 0 && scaleElements[0] && scaleElements[0].offsetWidth > 0) {
                elScaleMap = scaleElements[0];
            }
        }
        
        // Se não encontrou escala, cria uma padrão
        if (!elScaleMap) {
            console.warn('Nenhuma escala válida encontrada, criando escala padrão');
            
            const defaultScale = document.createElement('div');
            defaultScale.className = 'scale default-scale';
            defaultScale.style.cssText = `
                background: white;
                border: 2px solid rgba(0,0,0,0.2);
                border-top: none;
                padding: 0 5px;
                font-size: 11px;
                line-height: 18px;
                color: black;
                box-shadow: 0 0 0 1px rgba(255,255,255,0.5);
                white-space: nowrap;
                width: 80px;
                text-align: center;
            `;
            
            if (enabledPrintTwoBasemaps) {
                // Tenta calcular baseado no mapa se disponível
                const mapPrint = mapLeafletPrint;
                if (mapPrint && mapPrint.getZoom) {
                    const zoom = mapPrint.getZoom();
                    if (zoom < 10) {
                        defaultScale.textContent = '10 km';
                    } else if (zoom < 13) {
                        defaultScale.textContent = '5 km';
                    } else if (zoom < 15) {
                        defaultScale.textContent = '1 km';
                    } else {
                        defaultScale.textContent = '500 m';
                    }
                } else {
                    defaultScale.textContent = '1 km';
                }
            } else {
                defaultScale.textContent = '1 km';
            }
            
            document.body.appendChild(defaultScale);
            elScaleMap = defaultScale;
            
            setTimeout(() => {
                if (defaultScale.parentElement) {
                    defaultScale.parentElement.removeChild(defaultScale);
                }
            }, 1000);
        }
        
        // Clona e processa
        let cloneElScaleMap = elScaleMap.cloneNode(true);
        
        let hiddenScaleMap = document.getElementById('hidden-scale-map');
        if (!hiddenScaleMap) {
            // Cria o elemento se não existir
            hiddenScaleMap = document.createElement('div');
            hiddenScaleMap.id = 'hidden-scale-map';
            hiddenScaleMap.style.cssText = 'position: absolute; left: -999em; padding-top: 30px;';
            document.body.appendChild(hiddenScaleMap);
        }
        
        // Limpa conteúdo anterior
        while (hiddenScaleMap.firstChild) {
            hiddenScaleMap.removeChild(hiddenScaleMap.firstChild);
        }
        
        hiddenScaleMap.appendChild(cloneElScaleMap);
        
        let hiddenElScaleMap = hiddenScaleMap.firstChild;
        
        if (!hiddenElScaleMap || hiddenElScaleMap.offsetWidth === 0) {
            // Se ainda não tem dimensões, força dimensões
            hiddenElScaleMap.style.width = '80px';
            hiddenElScaleMap.style.height = '20px';
            hiddenElScaleMap.style.display = 'block';
        }
        
        return domtoimagemore.toPng(
            hiddenElScaleMap, 
            {
                height: hiddenElScaleMap.offsetHeight || 20,
                width: hiddenElScaleMap.offsetWidth || 80,
            }
        );
        
    } catch (error) {
        console.error('Erro em getImageScale:', error);
        
        // Cria imagem de escala de emergência
        const canvas = document.createElement('canvas');
        canvas.width = 80;
        canvas.height = 20;
        const ctx = canvas.getContext('2d');
        
        // Desenha escala simples
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, 80, 20);
        ctx.strokeStyle = 'rgba(0,0,0,0.2)';
        ctx.lineWidth = 2;
        ctx.strokeRect(1, 1, 78, 18);
        ctx.fillStyle = 'black';
        ctx.font = '11px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('1 km', 40, 14);
        
        return Promise.resolve(canvas.toDataURL());
    }
  };
  
  /**
   * Adiciona imagem da escala sobre o mapa
   */
    const buildScaleMap = useCallback((doc, imageScaleMap) => {   
      let initXImageMap, initYImageMap;
      
          if (enabledPrintTwoBasemaps) {  // escala dois mapas      
              if (gridCheck) {
                  // Com grid (dois mapas) 
                  initXImageMap = 345;  // ajusta direcionamento lado x
                  initYImageMap = 387;  // ajusta posicionamento de margin abaixo
              } else {
                  // Sem grid (dois mapas)
                  initXImageMap = 325;  // posição sem grid posicionamento
                  initYImageMap = 410;  // posição sem grid margin abaixo
              }
          } else {
              // escala mapa principal
              initXImageMap = 335;
              initYImageMap = gridCheck ? 388 : 410;
          }
          
          doc.addImage(imageScaleMap, "JPEG", initXImageMap, initYImageMap, 0, 0, '', 'NONE'); 
    }, [gridCheck, enabledPrintTwoBasemaps]);
  
  /**
   * Adiciona informação da fonte externa
   */
  const buildExternalSource = useCallback((doc) => {
    if (externalSource) {
      doc.setFontSize(8);
      doc.text("Fonte externa", 440, 300);
      doc.setDrawColor("#5E5E5E");
      doc.line(440, 302, 490, 302);
      doc.text(externalSource, 440, 310, { maxWidth: 145 });
    }    
  }, [externalSource]);

  /**
   * Obtém imagem do mapa de referência
   */
  const getImageReferenceMap = () => {
    try {
      let elReferenceMap = null;
      
      const minimapElements = document.getElementsByClassName("leaflet-control-minimap leaflet-container leaflet-touch leaflet-fade-anim leaflet-touch-zoom leaflet-control");
          
      // Procura por um minimap válido
      for (let i = 0; i < minimapElements.length; i++) {
        const minimap = minimapElements[i];
        if (minimap && minimap.offsetWidth > 0 && minimap.offsetHeight > 0) {
          elReferenceMap = minimap;
          break;
        }
      }
      
      // Fallback: busca qualquer elemento com classe leaflet-control-minimap
      if (!elReferenceMap) {
        const minimapFallback = document.querySelector('.leaflet-control-minimap');
        if (minimapFallback && minimapFallback.offsetWidth > 0) {
          elReferenceMap = minimapFallback;
        }
      }
      
      if (!elReferenceMap) {      
        // Cria um placeholder para o mapa de referência
        const placeholder = document.createElement('div');
        placeholder.style.cssText = `
          width: 120px;
          height: 120px;
          background: #f0f0f0;
          border: 2px solid #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #666;
          font-family: Arial, sans-serif;
        `;
        placeholder.textContent = 'Mapa de Referência';
        
        // Adiciona temporariamente ao DOM
        document.body.appendChild(placeholder);
        elReferenceMap = placeholder;
        
        // Remove após captura
        setTimeout(() => {
          if (placeholder.parentElement) {
            placeholder.parentElement.removeChild(placeholder);
          }
        }, 1000);
      }
      
      let cloneElReferenceMap = elReferenceMap.cloneNode(true);
      cloneElReferenceMap.style.width = "120px"; 
      cloneElReferenceMap.style.height = "120px";
      
      let hiddenReferenceMap = document.getElementById('hidden-reference-map');
      if (!hiddenReferenceMap) {
        return Promise.reject(new Error('hidden-reference-map não encontrado'));
      }
      
      // Limpa conteúdo anterior
      while (hiddenReferenceMap.firstChild) {
        hiddenReferenceMap.removeChild(hiddenReferenceMap.firstChild);
      }
      
      hiddenReferenceMap.appendChild(cloneElReferenceMap);
      
      let hiddenElReferenceMap = hiddenReferenceMap.firstChild;
      hiddenElReferenceMap.classList.remove('leaflet-control-minimap');
      
      // Remove link se existir
      const linkElement = hiddenElReferenceMap.querySelector('a');
      if (linkElement) {
        linkElement.remove();
      }
      
      return domtoimagemore.toPng(
        hiddenElReferenceMap, 
        {                       
          height: hiddenElReferenceMap.offsetHeight,
          width: hiddenElReferenceMap.offsetWidth,
        }
      );
      
    } catch (error) {
      console.error('Erro em getImageReferenceMap:', error);
      
      // Cria imagem de placeholder de emergência
      const canvas = document.createElement('canvas');
      canvas.width = 120;
      canvas.height = 120;
      const ctx = canvas.getContext('2d');
      
      // Desenha placeholder
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, 120, 120);
      ctx.strokeStyle = '#ccc';
      ctx.lineWidth = 2;
      ctx.strokeRect(0, 0, 120, 120);
      ctx.fillStyle = '#666';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('Mapa de', 60, 55);
      ctx.fillText('Referência', 60, 70);
      
      return Promise.resolve(canvas.toDataURL());
    }
  };

  /**
   * Adiciona imagem do mapa de referência no PDF
   */
  const buildReferenceMap = (doc, imageMapReference) => {
    let yPosition = 345;
    
    doc.setFontSize(8);
    doc.text("Mapa de referência", 440, yPosition);
    doc.setDrawColor("#5E5E5E");
    doc.line(440, yPosition + 2, 508, yPosition + 2);
    
    doc.addImage(imageMapReference, "JPEG", 440, yPosition + 8, 0, 0, '', 'NONE');
    // abre janela com impressão com o titulo definido no chrome, porém no firefox o nome sai como 'document.pdf'
    doc.output('dataurlnewwindow'); 
    // inicia download do arquivo com nome correto, porém so abre no firefox a depender da configuração e no chrome se
    // clica sobre o arquivo
    // doc.save('Output-GeoBahia.pdf');
  };

  /**
   * Oculta camadas não imprimíveis
   */
  const hideUnprintableLayers = useCallback(() => {
    layersToHide.forEach((lth) => {      
      mapLeafletPrint.removeLayer(lth);
    });
    return true;
  }, [layersToHide, mapLeafletPrint]); 

  const buildGridWithParams = useCallback((doc, coordsY, coordsX, leftCoordsX = null, rightCoordsX = null, leftCoordsY = null, rightCoordsY = null) => {
      doc.setFontSize(5);
      doc.setDrawColor("#5E5E5E");
      
      // Grid vertical dois mapas
      const coordsYToUse = (leftCoordsY?.length === 8) ? leftCoordsY : coordsY;
      buildVerticalGrid(doc, coordsYToUse, 57, 60, 57, 397, 8);
      
      // Grid Horizontal dois mapas: 8 COORDENADAS TOTAIS (4+4)
      buildHorizontalGrid(doc, coordsX, 59, 400, 360, 400, 4, leftCoordsX, rightCoordsX);
      
  }, [buildVerticalGrid, buildHorizontalGrid]);

  /**
   * Adiciona camadas selecionadas do geoserviço ao mapa
   */
  const generatePrint = useCallback(() => {
   setLoading(true);

  const doc = new jsPDF({
    orientation: "l",
    unit: "px",
    format: "a4",
    compress: false,
    autoSize: false,
    printHeaders: false
  });
  
  doc.setProperties({
    title: "Mapa Geobahia"
  });

  buildStaticLegendListOnDOM()
    .then(() => {        
      return getLegendList();
    })
    .then((arrLegendsBase64) => {         
      return convertImagesBase64ToObjWithDimensions(arrLegendsBase64);
    })
    .then((arrCustomObjImg) => {        
      buildBasicPdf(doc, arrCustomObjImg);
    })      
    .then(() => {        
      return getImageMap();
    })
    .then((mapImage) => {
      addMapImage(doc, mapImage);
    })
    .then(() => {
      if (gridCheck) {
        // modo dois mapas
        if (enabledPrintTwoBasemaps) {
          buildGridWithParams(
            doc,
            arrayCoordinatesY,        // 8 coordenadas Y
            arrayCoordinatesX,        // 4 coordenadas X padrão
            leftMapCoordinatesX,      // 4 coordenadas X mapa esquerdo
            rightMapCoordinatesX,     // 4 coordenadas X mapa direito
            leftMapCoordinatesY,      // 8 coordenadas Y mapa esquerdo
            rightMapCoordinatesY      // 8 coordenadas Y mapa direito
          );
        } else {
          // mapa principal
          buildGrid(doc);
        }
      }
    })
    .then(() => {
      if (northCheck) buildNorthMap(doc);
    })
    .then(() => {
        return getImageScale();
    })
    .then((imageScale) => {
      buildScaleMap(doc, imageScale);
    })
    .then(() => {
      buildExternalSource(doc);
    })
    .then(() => {
      return getImageReferenceMap();
    })
    .then((imageMapReference) => {
      buildReferenceMap(doc, imageMapReference);
    })
    .finally(() => {
      // Limpa conteúdo da área hidden do mapa de referência
      let hiddenReferenceMap = document.getElementById('hidden-reference-map');  
      while(hiddenReferenceMap.firstChild) {
        hiddenReferenceMap.removeChild(hiddenReferenceMap.firstChild);
      }

      // Limpa conteúdo da área hidden do mapa de referência
      let hiddenCloneMap = document.getElementById('hidden-map-reference-container');  
      while(hiddenCloneMap.firstChild) {
        hiddenCloneMap.removeChild(hiddenCloneMap.firstChild);
      }
              
      setLoading(false);
      onClose(true);
    });
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  buildStaticLegendListOnDOM, 
  getLegendList, 
  buildBasicPdf, 
  addMapImage, 
  buildGrid, 
  buildScaleMap, 
  buildExternalSource, 
  northCheck, 
  gridCheck, 
  onClose,
    leftMapCoordinatesX,   // ← ADICIONAR
  leftMapCoordinatesY,   // ← ADICIONAR
  rightMapCoordinatesX,  // ← ADICIONAR
  rightMapCoordinatesY   // ← ADICIONAR
]);

  /**
   * Define altura e largura do mapa na configuração 
   * e na impressão conforme seleção da grade de coordenadas
   */
  useEffect(() => {
    if (gridCheck) {
      setMaxWidthImg(maxInitialWidthMapPrint - spaceToGrid);
      setMaxHeightImg(maxInitialHeightMapPrint - spaceToGrid);
    } else {
      setMaxWidthImg(maxInitialWidthMapPrint);  
      setMaxHeightImg(maxInitialHeightMapPrint);
    }
  }, [gridCheck, maxWidthImg]);
  
  /**
   * Constroi mapa manipulável de referência para impressão
   */
  useEffect(() => {

    // Obtém mesmo mapa base do mapa da aplicação 
    // e adiciona no mapa da impressão
    const addBaseMapPrint = (mapReference) => {
      let baseMapMapPrint = basemaps.find((basemap) => 
        basemap.active
      ); 
      if (baseMapMapPrint?.atribuicao?.includes("(ano)")) {
        baseMapMapPrint.layer.options.attribution = baseMapMapPrint.atribuicao.replace(/\(ano\)|\d{2}\/\d{4}/g, localStorage.getItem("mapPlanet"));
      }      
      if(typeof baseMapMapPrint !== "undefined"){
        L.tileLayer(baseMapMapPrint.layer._url, {          
          attribution: baseMapMapPrint.layer.options.attribution
        }).addTo(mapReference);
      } 
    };

    // Constroi mada da impressão
    const buidMapPrint = () => {

      //Calcula as coordenadas longitudinais e latitudinais do mapa para o grid de coordenadas
      const coordinatesRealTime = (numOfLines = 2) => {        
        let northEastLat = mapLeafletPrint.getBounds()._northEast.lat;
        let latYTop = northEastLat.toFixed(5) + "°";    
        let southWestLat = mapLeafletPrint.getBounds()._southWest.lat;
        let latYBottom = southWestLat.toFixed(5) + "°";

        let southWestLng = mapLeafletPrint.getBounds()._southWest.lng;
        let latXLeft = southWestLng.toFixed(5) + "°";    
        let northEastLng = mapLeafletPrint.getBounds()._northEast.lng;
        let latXRight = northEastLng.toFixed(5) + "°";  
        
        let arrayCoordinatesY = [latYTop, latYBottom];
        let arrayCoordinatesX = [latXLeft, latXRight];

          if (numOfLines > 2) {            
              let divisor = numOfLines - 1;
              let numGrid = 1;      
              
              let rangeCoordinatesLat = ((southWestLat - northEastLat) / divisor) * numGrid;
              let yCoordinate;            

              let rangeCoordinatesLng = ((northEastLng - southWestLng) / divisor) * numGrid;
              let xCoordinate; 
              
              while (numOfLines > 2) {            
                  yCoordinate = ((rangeCoordinatesLat * numGrid) + northEastLat).toFixed(5) + "°";
                  arrayCoordinatesY.push(yCoordinate);
                  xCoordinate = ((rangeCoordinatesLng * numGrid) + southWestLng).toFixed(5) + "°";
                  arrayCoordinatesX.push(xCoordinate);
                  numOfLines--;
                  numGrid++;
              }  

              setArrayCoordinatesY(arrayCoordinatesY)
              setArrayCoordinatesX(arrayCoordinatesX)
          }
        }

      let mapLeafletPrint = L.map('leaflet-map-ajust-print', {
        center: [map.getCenter().lat, map.getCenter().lng],
        zoom: map._zoom,
        zoomControl: false,
        preferCanvas: true,
      });

      //Adiciona controle de zoom na canto superior direito
      new L.Control.Zoom({ position: 'topright' }).addTo(mapLeafletPrint);

      mapLeafletPrint.pm.setLang('pt_br');
      mapLeafletPrint.pm.setGlobalOptions({
        tooltips: false,
      });

      const mixedPanePrint = mapLeafletPrint.createPane('mixedPanePrint');
      mixedPanePrint.style.zIndex = 300;

      setMapLeafletPrint(mapLeafletPrint);
      setInicializedPrintMap(true);
      addBaseMapPrint(mapLeafletPrint);

      //Escuta o qualquer movimento no mapa manipulavel da impressão
      mapLeafletPrint.on('move', function() {
        coordinatesRealTime(8)
      });

      return mapLeafletPrint;
    };  
    
    // Configura os rótulos da camada
    const configureTooltip = (oldLayer, newLayer) => {
      let featureTooltip = oldLayer.leafletLayer._layers[Object.keys(oldLayer.leafletLayer._layers)[0]].getTooltip();
      let settingsLabel = {};
      if (featureTooltip) {
        Object.values(newLayer._layers).forEach((feature) => {            
          settingsLabel = {
            ...featureTooltip.options,              
            feature: feature,              
          };
          applyLabelSetting(settingsLabel);        
        });
      }
    };  

    // Prepara camadas a serem adicionadas no mapa da
    // impresão a partir das camadas do mapa da aplicação
    const buidLayersToMapPrint = async (buidLayersToMapPrint) => {
      let arrLayersToAddMapPrint = [];

      getValidLayers().forEach((validLayer) => {        
        let layerFromMapApp = validLayer.layer;             
        let layerAliasName = layerFromMapApp.type === 'externa' ? layerFromMapApp.properties.titulo : validLayer.aliasName;           
        let layerType = layerFromMapApp.type;
        let newLayerToMapPrint = null;
        // Verifica quando a camada é interna se é do tipo WFS ou WMS
        let service = layerFromMapApp.additionalProps?.service;

        if (layerFromMapApp.type === 'importada' || layerFromMapApp.type === 'criada' || service === 'WFS') {
          // Estilização da camada
          let layerStyle = {
            ...layerFromMapApp.layerStyle,
            opacity: layerFromMapApp.layerStyle.opacity,            
            fillOpacity: layerFromMapApp.layerStyle.fillOpacity,
          };
          const customRender = L.canvas({ pane: 'mixedPanePrint'});                 
          // Configura o options
          let options = {
            pane: 'mixedPanePrint',
            renderer: customRender,
            style: function (feature) {
              if (layerFromMapApp.classList.length > 0) {
                let featureStyle = layerFromMapApp.classList.find((c) => 
                  c.value === feature.properties[layerFromMapApp.classColumn]
                );
                
                if (featureStyle) {
                  layerStyle = {
                    ...layerStyle,
                    color: featureStyle.simbology.fillColor,      
                    fillColor: featureStyle.simbology.fillColor, 
                  }
                }
              }
              return layerStyle;
            },            
          };

          // Garante estilização para camadas com geometrias do tipo ponto
          if (layerFromMapApp.dataType === 'Point' || 
            layerFromMapApp.dataType === 'MultiPoint' ||
            layerFromMapApp.dataType === 'Text') {
            layerStyle.fillOpacity = layerStyle.opacity
            options = {
              ...options,
              pointToLayer: function (feature, latlng) {
                if (layerFromMapApp.dataType === 'Text') {
                  let markerTextArea =  L.marker(latlng, {
                    pane: 'mixedPanePrint',                  
                    renderer: customRender,
                    textMarker: true,
                    text: feature.properties.Texto,
                  });                 
                  let markerTextAreaElement =  markerTextArea.pm.getElement();
                  
                  markerTextAreaElement.classList.add('markerTextAreaGb');
                  markerTextAreaElement.classList.add('markerTextAreaPrintGb');                  
                  
                  return markerTextArea;
                } else {
                  let circleMarker = L.circleMarker(latlng, {
                    pane: 'mixedPanePrint',
                    ...layerStyle,
                    renderer: customRender,
                  });
                  if (layerFromMapApp.fileType === "jpg/jpeg" || feature?.imageUrl) {                  
                    let iconDefaultJpegJpg = L.icon({
                      pane: 'mixedPanePrint',
                      renderer: customRender,
                      iconUrl: JpegJpgIconMap,
                      iconAnchor: [9, 9],
                    });
                    let iconClikedJpegJpg = L.icon({
                        pane: 'mixedPanePrint',
                        renderer: customRender,
                        iconUrl: JpegJpgIconMapCliked,
                        iconAnchor: [9, 9],
                    });
                    var markerJpegJpg = L.marker(latlng, {
                      pane: 'mixedPanePrint',
                      renderer: customRender,
                      icon: iconDefaultJpegJpg                
                    });
                    
                    markerJpegJpg.on('popupopen', function(e) {
                      e.target.setIcon(iconClikedJpegJpg);                    
                    });
                    markerJpegJpg.on('popupclose', function(e) {
                      if (buidLayersToMapPrint.hasLayer(e.target)) e.target.setIcon(iconDefaultJpegJpg);
                    });
      
                    let popup = L.popup({
                      autoClose: false, 
                      closeOnClick: false,
                      closeButton: false,
                      className: 'custom-leaflet-popup-jpg-jpeg-layer',              
                    })
                    .setLatLng(latlng)
                    .setContent(PopupImage(feature.imageUrl, markerJpegJpg));              
                    markerJpegJpg.bindPopup(popup); 
  
                    if (feature.popupOpen) {
                      buidLayersToMapPrint.openPopup(popup);
                    }                  
  
                    return markerJpegJpg;
                  }
                  return circleMarker
                }
                
              },
            };
          }
          
          let geoJsonLayer = layerFromMapApp.leafletLayer.toGeoJSON();
          newLayerToMapPrint = L.geoJSON(geoJsonLayer, options);                    
          configureTooltip(layerFromMapApp, newLayerToMapPrint);          
        } else if(layerFromMapApp.type === 'importada-raster') {                           
          newLayerToMapPrint = layerFromMapApp.leafletLayer;
          newLayerToMapPrint.fileRaster = layerFromMapApp.geoRasterLayer;
        } else {          
          const optionsWms = {
            layers: layerFromMapApp.getLayerNameParam(),
            format: 'image/png',
            transparent: true,
            pane: 'mixedPanePrint',
            tiled: true,
            opacity: layerFromMapApp.layerStyle.opacity,             
          };

          if (layerFromMapApp.properties?.srs && L.CRS[layerFromMapApp.properties.srs]) {
            optionsWms.crs = L.CRS[layerFromMapApp.properties.srs];
          }
          
          // Verifica se a camada esta configurada para
          // se exibida na abertura da aplicação
          if (layerFromMapApp.additionalProps?.mainMenu) {          
            newLayerToMapPrint = new NonTiledLayer
              .WMS(
                layerFromMapApp.getServiceLink(layerFromMapApp.getService()), 
                {
                  ...optionsWms,
                  crossOrigin: 'anonymous',
                }
              );
          } else {          
            newLayerToMapPrint = L.tileLayer
              .wms(
                layerFromMapApp.getServiceLink(layerFromMapApp.getService()), 
                optionsWms
              ); 
          }
        }
        
        newLayerToMapPrint.aliasName = layerAliasName;
        newLayerToMapPrint.type = layerType;
        arrLayersToAddMapPrint.push(new Promise((resolve, reject) => {
          resolve(newLayerToMapPrint);
        })); 
      });
      
      return Promise.all(arrLayersToAddMapPrint);
    };

    // Adiciona camadas no mapa da impressão
    const addLayersOnMapPrint = async (arrLayersToPrintMap, buildedMapLeafletPrint) => {       
      const countLayers = arrLayersToPrintMap.length;           
      arrLayersToPrintMap.forEach((ltpm, i) => {
        const zIndexLayer = countLayers - i + 10;
        if (ltpm.fileRaster) {
          let fileReader = new FileReader();
          fileReader.onloadend = (e) => {
            let fileReaderResult = fileReader.result;
              parseGeoraster(fileReaderResult)
                .then((georaster) => {              
                  let rasterLayer = new GeoRasterLayer({
                    georaster: georaster,                    
                    opacity: ltpm.options.opacity,
                    resolution: 256 // optional parameter for adjusting display resolution
                  });
                  rasterLayer.addTo(buildedMapLeafletPrint);
                });
          };
          fileReader.readAsArrayBuffer(ltpm.fileRaster);
        } else {          
          let addedLayer = ltpm.addTo(buildedMapLeafletPrint);    
          if (addedLayer.setZIndex) {
            addedLayer.setZIndex(zIndexLayer);           
          }
        }      
      });
    };
    
   if (!inicializedPrintMap) {
      let buildedMapLeafletPrint = buidMapPrint();

      buidLayersToMapPrint(buildedMapLeafletPrint)
        .then(async (arrLayersToPrintMap) => {  
          setLayersPrintMap(arrLayersToPrintMap);

          if (!enabledPrintTwoBasemaps) {
            addLayersOnMapPrint(arrLayersToPrintMap, buildedMapLeafletPrint);
          }
          
          // Marca que as camadas estão prontas
          setLayersReady(true);
        });
    }
        
  }, [map, basemaps, getValidLayers, inicializedPrintMap, arrayCoordinatesY, arrayCoordinatesX, changeAttributionDinamic, enabledPrintTwoBasemaps]);
  
  //Realiza a "força" o primeiro move para execução do metodo que calcula as coordenadas
  useEffect(() => {           
    if(mapLeafletPrint){
      mapLeafletPrint.fire('move')
    }
  }, [gridCheck, mapLeafletPrint]);

  /**
   * Habilita botão de impressão conforme preenchimento do formulário
   */
  useEffect(() => {           
    if (title.trim() && subtitle.trim()) {
      setDisableSubmitPrint(false);      
    } else {
      setDisableSubmitPrint(true);
    }
  }, [title, subtitle]);

  /**
   * Inicia impressão
   */
  useEffect(() => {           
    if (startPrint) {      
      if (layersToHide.length > 0) {
        let arrAliasNameLayersNotPrint = layersToHide.map((l) => l.aliasName);                          
        geoConfirm({
          message: 'As seguintes camadas não poderão ser impressas: ' + arrAliasNameLayersNotPrint.join(', ') + '. Deseja Continuar?',
          callback: (confirmed) => {
            confirmed && hideUnprintableLayers() && generatePrint();
          },
        });
      } else {
        generatePrint();
      }
      setStartPrint(false);
    }
  }, [startPrint, layersToHide, hideUnprintableLayers, generatePrint]);

  useEffect(() => {
    const tools = activeModule.elementosConfig
    const searchKey = "CPN-TB-RA-SIDE-BY-SIDE-PRINT";

    for (let key in tools) {
      if (key === searchKey) {
        setIsActivePrintTwoBasemaps(true)
      }
    }
  }, [activeModule.elementosConfig]);

  const handlePrintTwoBasemaps = (event) => {
    setEnabledPrintTwoBasemaps(event.target.checked)
  };
  
  useEffect(() => {
  if (!enabledPrintTwoBasemaps && mapLeafletPrint) {
    // Força a reinicialização do mapa
    setInicializedPrintMap(false);
    setLayersReady(false); // Reset do estado das camadas
    
    // Aguarda a atualização do DOM antes de reinicializar
    setTimeout(() => {
      const mapElement = document.getElementById('leaflet-map-ajust-print');
      if (mapElement && !mapElement._leaflet_id) {
        setMapLeafletPrint(null);
      }
    }, 50);
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [enabledPrintTwoBasemaps]);

useEffect(() => {
  if (!enabledPrintTwoBasemaps) {
    // Remove qualquer ícone norte dos dois mapas quando não está no modo
    const existingIcons = document.querySelectorAll('.two-maps-north-icon');
    existingIcons.forEach((icon) => icon.remove());
    return;
  }

  const timeout = setTimeout(() => {
    const rightContainer = document.querySelector('.two-maps-right');

    if (!rightContainer) {
      return;
    }

    const existingIcons = document.querySelectorAll('.two-maps-north-icon');
    existingIcons.forEach((icon) => icon.remove());

    if (northCheck) {
      // Função para criar ícone de norte
      const createNorthIcon = (container, mapName) => {
        const northIcon = document.createElement('div');
        northIcon.className = 'two-maps-north-icon topRight'; 
        
        northIcon.style.cssText = `
          position: absolute;
          top: 20px;
          right: 13px;
          z-index: 1000;
          pointer-events: none;
        `;
        
        container.appendChild(northIcon);
        
        ReactDOM.render(<Icon i="map-north" />, northIcon);
        
      };

      // Cria ícones apenas para o lado direito
      createNorthIcon(rightContainer, 'mapa direito/inferior');

    }
  }, 1000);

  return () => {
    clearTimeout(timeout);
    // Limpeza: remove apenas os ícones que criamos
    const icons = document.querySelectorAll('.two-maps-north-icon');
    icons.forEach((icon) => {
      ReactDOM.unmountComponentAtNode(icon);
      icon.remove();
    });
  };
}, [enabledPrintTwoBasemaps, northCheck, layersReady]);

  return (
    <Wrap
      widthMap={maxWidthImg}
      heightMap={maxHeightImg}
      gridCheck={gridCheck}
    >
      {loading && (
        <div className="loader">
          <CircularProgress color="inherit" />
        </div>
      )}
      <aside>
        <form action="">  
          <div className='overflow'>
            <div className='hidden'>
              <div>
                <h2>Predefinições</h2>
                <hr />
                <div className='marginLabel displayPrinter'>  
                  <div>
                    <label>Impressora</label> <br />      
                    <select className='selectPrinter'>
                      <option value="">Adobe PDF</option>
                      <option value="">Impressora 2</option>                 
                    </select>                          
                  </div>           
                  <div>
                    Propriedades
                  </div>
                </div>
              </div>  

              <div className='distanceBox1'>                
                <div className='size marginLabel'>
                  <div>
                    <label>Tamanho</label> <br />               
                    <select className='selectSize'>
                      <option value="A3">A3</option>
                      <option value="A4">A4</option>                  
                    </select>
                  </div>
                  <div className='orientation'>                
                    <label>Orientação</label> <br/>
                    <select className='selectOrientation'>              
                      <option value="">Paisagem</option>
                      <option value="">Horizontal</option>                  
                    </select>
                  </div>
                  <div className='leiaute'>
                    <label>Leiaute</label> <br />  
                    <div className='iconsLeiaute'>
                      <Icon
                        i="map-leiautepaisagem"                                    
                      />           
                    </div>
                    <div className='iconsLeiaute iconRetrato'>
                      <Icon
                        i="map-leiauteretrato"                                    
                      />           
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='distanceBox2'>          
              <h2>Configuração do arquivo</h2>
              <hr />
              <div className='marginLabel marginFields'>
                <label>Título</label> <br />
                <input
                  className="inputText"
                  type="text"
                  placeholder='Insira título do projeto (máx. 50 caracteres)'
                  onChange={(e) => setTitle(e.target.value)}
                  maxLength="50"
                />
              </div>
              <div className='marginLabel marginFields'>
                <label>Subtítulo</label> <br />
                <input
                  className="inputText"
                  type="text"
                  placeholder='Insira subtítulo do projeto (máx. 50 caracteres)'
                  onChange={(e) => setSubtitle(e.target.value)}
                  maxLength="50"
                />
              </div>
              <div className='marginLabel marginFields hidden'>
                <div>
                  <div className='checkbox'><input type="checkbox" /><label>Legenda</label></div>              
                  <div className='checkbox'><input type="checkbox" /><label>Fonte</label></div>
                  <div className='checkbox'><input type="checkbox" /><label>Grade de Coordenadas</label> </div>
                  <div className='distanceLabelCheckbox'></div>                   
                  <div className='checkbox'><input type="checkbox" /><label>Mapa de referência</label></div>
                  <div className='checkbox'><input type="checkbox" /><label>Norte</label></div>                                                                   
                </div>
              </div>

              <div className='marginLabel marginFields'>
                <div>                
                  <div className='checkbox'>
                    <input
                      type="checkbox"
                      checked={northCheck}
                      onChange={(e) => setNorthCheck(!northCheck)}
                    />
                    <label>Norte</label>
                    </div>
                  <div className="checkbox">
                  <input
                    type="checkbox"
                    checked={gridCheck}
                    onChange={() => setGridCheck(!gridCheck)}
                  />
                  <label>Grade de Coordenadas</label>
                  <br />
                  <span
                    className="warning"
                    style={{ visibility: gridCheck ? 'visible' : 'hidden' }}
                  >
                    Ao adicionar a grade ocorrerá perda de área do mapa.
                  </span>
                </div>
                </div>
              </div>

              <div className='marginLabel marginFields externalSource'>
                <label>Fonte Externa</label><br/>
                <input
                  className="inputText"
                  type="text"
                  placeholder='Insira o local da análise (máx. 200 caracteres)'
                  onChange={(e) => setExternalSource(e.target.value)}
                  maxLength="200"
                />
              </div>

              {isActivePrintTwoBasemaps && (
                <>
                <br />
                <div className="button-area">
                  <PrintTwoBaseMaps
                    enabledPrintTwoBasemaps={enabledPrintTwoBasemaps}
                    handlePrintTwoBasemaps={handlePrintTwoBasemaps}
                  />
                </div>
                </>
              )}

              {/* Orientação horizontal e vertical modo dois mapas} */}
              {/* {enabledPrintTwoBasemaps && (
                <div className='marginLabel marginFields'>
                  <label>Orientação</label><br/>
                  <LayoutOptions>
                    <LayoutOption 
                      selected={layoutOrientation === 'vertical'}
                      onClick={() => setLayoutOrientation('vertical')}
                    >
                      <LayoutIcon horizontal={true}>
                        <LayoutIconSection primary={true} horizontal={true} />
                        <LayoutIconSection primary={false} horizontal={true} />
                      </LayoutIcon>
                      <LayoutLabel>Vertical</LayoutLabel>
                    </LayoutOption>

                    <LayoutOption 
                      selected={layoutOrientation === 'horizontal'}
                      onClick={() => setLayoutOrientation('horizontal')}
                    >
                      <LayoutIcon horizontal={false}>
                        <LayoutIconSection primary={true} horizontal={false} />
                        <LayoutIconSection primary={false} horizontal={false} />
                      </LayoutIcon>
                      <LayoutLabel>Horizontal</LayoutLabel>
                    </LayoutOption>
                  </LayoutOptions>
                </div>
              )} */}

            </div>
          </div> 
        </form>
        <div className="footer">
          <div className="button-area">
            <Button
              variant="contained"
              disabled={disableSubmitPrint}
              onClick={(e) => {
                getUnprintableLayers()
                  .then((unprintableLayers) => {                    
                    unprintableLayers = unprintableLayers.filter(Boolean);                     
                    setLayersToHide(unprintableLayers);
                    setStartPrint(true);                
                  });
              }}
            >
              Imprimir
            </Button>
          </div>
        </div>
      </aside>
      {enabledPrintTwoBasemaps && layersReady && layersPrintMap ? (
        <PrintTwoBasemapsView 
          mapInstanceLeft={mapInstanceLeft}
          mapInstanceRight={mapInstanceRight}
          enabled={enabledPrintTwoBasemaps}
          basemaps={basemaps}
          map={mapLeafletPrint}
          layersPrintMap={layersPrintMap}
          layoutOrientation={layoutOrientation}
          gridCheck={gridCheck}
          arrayCoordinatesX={arrayCoordinatesX}
          arrayCoordinatesY={arrayCoordinatesY}
          onCoordinatesUpdate={handleTwoMapsCoordinatesUpdate}  
        />
      ) : (
        <div className="map-side">
          <div className="container-map"> 
            {gridCheck && (
              <div className="vertical-grid">
                <GridVertical 
                  arrayY={arrayCoordinatesY}
                />
              </div>       
            )}
            <div id="leaflet-map-ajust-print">
            </div>
            {northCheck && (         
            <div className='topRight'>
                  <Icon i="map-north" />
            </div> 
            )}
            {mapLeafletPrint && (
              <div className="bottomRight">
                <Scale map={mapLeafletPrint} />          
              </div>
            )}        
          </div>
          <div className="container-horizontal-grid">
            {gridCheck && (
              <div className="horizontal-grid">
                <GridHorizontal 
                  arrayX={arrayCoordinatesX}
                />
              </div>       
            )}
          </div>
        </div>
      )}
      <div className="content">        
        <div id="hidden-legend-content" style={{position:'absolute', left: '-999em'}}>
          {hiddenLegends}
        </div>
        <div id="hidden-scale-map" style={{position:'absolute', left: '-999em', paddingTop:'30px'}}>
          {/* {referenceMap} */}
        </div>
        <div id="hidden-reference-map" style={{position:'absolute', left: '-999em', paddingTop:'30px'}}>
          {/* {referenceMap} */}
        </div>
      </div>      
      <div id="hidden-map-reference-container" style={{position:'absolute', left: '-999em'}}>        
      </div>
    </Wrap>    
  );
};

export default PrintView;
